// src/pages/Logout.jsx
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { clearAdminHint } from "../contexts/ImpersonationContext";
import { setActingOrgId } from "../utils/api";

const getRedirectUri = () => {
  const customDomain = process.env.REACT_APP_CUSTOM_DOMAIN || "studio.assertion-ai.com";
  const protocol = window.location.protocol;
  const currentOrigin = window.location.origin;
  
  // Always use custom domain for production redirects
  if (process.env.NODE_ENV === "production" || currentOrigin.includes(customDomain)) {
    return `${protocol}//${customDomain}`;
  }
  return currentOrigin;
};

const Logout = () => {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    const run = async () => {
      try {
        // Drop the per-browser admin hint and any acting scope on the way out, so the next
        // person to sign in on this browser never sees admin controls or inherits a
        // view-as scope from the previous session.
        clearAdminHint();
        setActingOrgId(null);
        const account = instance.getActiveAccount?.() || accounts?.[0];
        await instance.logoutRedirect({
          account,
          postLogoutRedirectUri: getRedirectUri(),
        });
      } catch (err) {
        console.error("Logout failed:", err);
      }
    };
    run();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // A neutral screen while the redirect happens: this page is reached from the memory product too,
  // where flashing the analytics shell (which it used to render) looked like the wrong app.
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center",
               justifyContent: "center", gap: 2, bgcolor: "#0b0b0f", color: "#fff" }}>
      <CircularProgress size={28} sx={{ color: "#2da894" }} />
      <Typography sx={{ opacity: 0.7, fontSize: 14 }}>Signing out…</Typography>
    </Box>
  );
};

export default Logout;